import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { RootBoundary } from './components/RootBoundary';
import { AuthProvider } from './contexts/AuthContext';
import './i18n/config';
import './styles/globals.css';
import './styles/screens.css';
import './styles/reset.css';
import './styles/responsive.css';
import './styles/atelier.css';
import './styles/interactive.css';
import './styles/decorative.css';
import './styles/homework-v2.css';
import './styles/surfaces.css';
import './styles/legal.css';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(root).render(
  <StrictMode>
    <RootBoundary>
      <AuthProvider>
        <App />
      </AuthProvider>
    </RootBoundary>
  </StrictMode>,
);
